import styled from "styled-components";
import { Box, Typography } from "@material-ui/core";

export const BackgroundImageContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60%;
    height: 100vh;
    background-image: url("login_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: scroll;
    image-rendering: crisp-edges;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const LoginWrapper = styled(Box)`
    padding: 90px 120px 0 80px;
    background-color: #ffffffef;
    width: 40%;
    min-height: 100vh;
    overflow: auto;

    @media (max-width: 768px) {
        padding: 50px 10px 10px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
`;

export const Row = styled(Box)`
    display: flex;
    margin: 30px 0;

    @media (max-width: 768px) {
        justify-content: center;
        margin: 15px 0;
    }
`;

export const WelcomeText = styled(Typography)`
    font-size: 18px;

    @media (max-width: 768px) {
        text-align: center;
    }
`;

export const LoginForm = styled.form`
    @media (max-width: 768px) {
        width: 100%;
        margin-top: 80px;
    }
`;

export const InputWrapper = styled(Box)`
    & .MuiInputBase-input {
        @media (max-width: 768px) {
            height: 48px;
            box-sizing: border-box;
            width: 300px;
        }
    }

    & .MuiFormControl-root {
        @media (max-width: 768px) {
            box-sizing: border-box;
            width: 300px;
            margin: 15px 0;
        }
    }
`;

export const ForgotPasswordLink = styled.span`
    display: block;
    margin-top: 25px;
    color: #007aff;
    cursor: pointer;
    text-decoration: underline;
    font-size: 12px;

    &:hover {
        opacity: 0.8;
    }
`;

export const ErrorMessage = styled(Typography)`
    color: red;
`;
